import { IFormStyleConfig } from "../../../../../components/Form/interface/form.interfaces";

export const signUpFormStyles: IFormStyleConfig = {
    // 1. Container & Wrappers
    container: { gap: '1.5rem' },
    fieldWrapper: { display: 'flex', flexDirection: 'column', gap: '0.5rem' },

    // 2. Text & Elements
    label: {
        fontWeight: 300,
        color: '#32240fff',
        fontSize: '0.9rem'
    },
    helperText: {
        color: '#f9a127ff',
        fontSize: '0.8rem'
    },
    errorText: {
        color: '#d32f2f',
        fontSize: '0.8rem',
        marginTop: '0.25rem'
    },
    submitButton: {
        backgroundColor: '#f9a127ff',
        color: '#ffffff',
        padding: '0.75rem 1.5rem',
        borderRadius: '8px',
        border: 'none',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        width: '100%',
        marginTop: '1.5rem' // Slightly larger top margin for the sign up submit
    },

    // 3. Shared Input Styles
    sharedInputs: {
        borderRadius: '8px',
        border: '1px solid var(--fx-surface-border, #E2E8F0)',
        padding: '0.75rem 1rem',
        fontSize: '1rem',
        color: '#32240fff',
        backgroundColor: 'var(--fx-surface-base, #FFFFFF)',
        outline: 'none',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        width: '100%',
        boxSizing: 'border-box'
    },

    // 4. Unique Input Styles
    text: { height: '48px' },
    textarea: { minHeight: '120px', resize: 'vertical' },
    select: { cursor: 'pointer', height: '48px' },
    address: { height: '48px' },
};
